import ctx from "../../plugins/axios";

/**
 * Gets the Overview details.
 *
 * @returns {Promise<*>}
 */
const getDetails = async (selectedBrand) => {
    let queryStr;
    const thpcValue = selectedBrand.thpc && selectedBrand.thpc !== 'undefined' ? selectedBrand.thpc : '';
    const brandValue = selectedBrand.brand && selectedBrand.brand !== 'undefined' ? selectedBrand.brand : '';
    
    // When brand is empty and userBrands are provided, send them as comma-separated list
    const userBrandsValue = selectedBrand.userBrands && Array.isArray(selectedBrand.userBrands) 
        ? selectedBrand.userBrands.join(',') 
        : '';
    
    queryStr = `/specialty_list?brand=${brandValue}&thpc_nm=${thpcValue}&user_brands=${userBrandsValue}`;
    return await ctx.get(queryStr);
};

export default getDetails;